import { Col, Form, FormControl, FormGroup, InputGroup, Row } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";

import { useTranslateContext } from "../../contexts/translate.context";

import { toInt, toString } from "../../utilities/auxiliary-functions";
import { useEffect } from "react";

export interface IRuleBenefitRecordProps {
    title: any,
    isEdit: boolean,
    identifier: boolean,
    viewOnly?: boolean,

    listBenefit: any,
    listCategory: any,
    listService: any,
    listRegulation: any,
    listAmount: any,
    listCondition: any,

    created?: any,
    updated?: any,
    setCreated?: any,
    setUpdated?: any,

    benefitId: any,
    launch: any,
    category: any,
    service: any,
    regulation: any,
    cost: any,
    amount: any,
    description: any,
    condition: any,
    initial: any,
    final: any,
    setBenefitId: any,
    setLaunch: any,
    setCategory: any,
    setService: any,
    setRegulation: any,
    setCost: any,
    setAmount: any,
    setDescription: any,
    setCondition: any,
    setInitial: any,
    setFinal: any,
}

export const RuleBenefitRecord: React.FC<IRuleBenefitRecordProps> = (props: IRuleBenefitRecordProps) => {

    const { display } = useTranslateContext();

    function onChangeBenefit(event: any) {
        const id = event.target.value;
        props.setBenefitId(toInt(id));
        const benefit = props.listBenefit.filter((benefit: any) => { return benefit.id === toInt(id)});
        props.setCategory(benefit[0].category);
    }

    function viewCost(value: string) {
        let costsRegulation = [] as any;
        for (let i = 5; i <= 50; i++) {
            if (i % 5 === 0) {
                var selected = (i === toInt(value));
                costsRegulation.push(<option key={i} selected={selected} value={i}>{i} %</option>);
            }
        }
        return costsRegulation;
    }

    return (
        <>
            <Row>
                <Col>
                    <FormGroup>
                        <Form.Label htmlFor="form-benefit">{display.label.beneficiary}</Form.Label>
                        <Form.Select id="form-benefit" name="benefit"  
                            disabled={!props.isEdit}
                            value={props.benefitId} 
                            onChange={(e: any) => onChangeBenefit(e)}
                            // onChange={(e: any) => props.setBenefitId(e.target.value)}
                        >
                            { props.benefitId === 0 ? (
                                <option value="">...</option>
                            ) : null }
                            { props.listBenefit.map((iterator: any, idx: number) => (<option key={idx} value={iterator.id}>{iterator.codiname}</option>)).sort((a : any, b : any) => { return a.props.children > b.props.children ? 1 : -1; }) }
                        </Form.Select>
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <Form.Label htmlFor="form-launch">{display.label.date_launch}</Form.Label>
                        <Form.Control id="form-launch" name="launch" required placeholder={display.example.launch}
                            disabled={!props.isEdit}
                            readOnly={true}
                            value={props.launch}
                            onChange={(e: any) => props.setLaunch(e.target.value)}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Form.Label htmlFor="form-category">{display.label.category}</Form.Label>
                        <Form.Select id="form-category" name="category"  
                            disabled={!props.isEdit}
                            value={props.category} 
                            onChange={(e: any) => props.setCategory(e.target.value)}
                        >
                            { props.category === "" ? (
                                <option value="">...</option>
                            ) : null }
                            { props.listCategory.map((iterator: any, idx: number) => (<option key={idx} value={iterator.identifier}>{iterator.name}</option>)).sort((a : any, b : any) => { return a.props.children > b.props.children ? 1 : -1; }) }
                        </Form.Select>
                    </FormGroup>
                </Col>
            </Row>
            <Row sm="12" className="ms-1 me-1"><Col className="ps-1 pe-1" ><hr /></Col></Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Form.Label htmlFor="form-service">{display.label.service}</Form.Label>
                        <Form.Select id="form-service" name="service"  
                            disabled={!props.isEdit}
                            value={props.service} 
                            onChange={(e: any) => props.setService(e.target.value)}
                        >
                            { props.service === "" ? (
                                <option value="">...</option>
                            ) : null }
                            { props.listService.map((iterator: any, idx: number) => (<option key={idx} value={iterator.identifier}>{iterator.name}</option>)).sort((a : any, b : any) => { return a.props.children > b.props.children ? 1 : -1; }) }
                        </Form.Select>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Form.Label htmlFor="form-regulation">{display.label.regulation}</Form.Label>
                        <Form.Select id="form-regulation" name="regulation"  
                            disabled={!props.isEdit}
                            value={props.regulation} 
                            onChange={(e: any) => props.setRegulation(e.target.value)}
                        >
                            { props.regulation === "" ? (
                                <option value="">...</option>
                            ) : null }
                            { props.listRegulation.map((iterator: any, idx: number) => (<option key={idx} value={iterator.identifier}>{iterator.name}</option>)).sort((a : any, b : any) => { return a.props.children > b.props.children ? 1 : -1; }) }
                        </Form.Select>
                    </FormGroup>
                </Col>
                {props.regulation === 'PERCENTUAL' ? (
                    <Col>
                        <FormGroup>
                            <Form.Label htmlFor="form-cost">{display.label.cost}</Form.Label>
                            <Form.Select id="form-cost" name="cost" 
                                disabled={!props.isEdit} 
                                value={toInt(props.cost)} 
                                onChange={(e: any) => props.setCost(e.target.value)}
                            >
                                {viewCost(props.cost)}
                            </Form.Select>
                        </FormGroup>
                    </Col>
                ) : props.regulation === 'VALOR' ? (
                    <Col>
                        <FormGroup>
                            <Form.Label htmlFor="form-cost">{display.label.cost}</Form.Label>
                            <Form.Control id="form-cost" name="cost" required placeholder={display.example.cost}
                                disabled={!props.isEdit}
                                value={props.cost}
                                onChange={(e: any) => props.setCost(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                ) : null }
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Form.Label htmlFor="form-amount">{display.label.amount}</Form.Label>
                        <Form.Select id="form-amount" name="amount" 
                            disabled={!props.isEdit}
                            value={props.amount} 
                            onChange={(e: any) => props.setAmount(e.target.value)}
                        >
                            { props.amount === "" ? (
                                <option value="">...</option>
                            ) : null }
                            { props.listAmount.map((iterator: any, idx: number) => (<option key={idx} value={iterator.identifier}>{iterator.name}</option>)).sort((a : any, b : any) => { return a.props.children > b.props.children ? 1 : -1; }) }
                        </Form.Select>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Form.Label htmlFor="form-description">{display.label.description}</Form.Label>
                        <Form.Control id="form-description" name="description" required placeholder={display.example.description}
                            disabled={!props.isEdit}
                            value={props.description}
                            onChange={(e: any) => props.setDescription(e.target.value)}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Form.Label htmlFor="form-condition">{display.label.condition}</Form.Label>
                        <Form.Select id="form-condition" name="condition"  
                            disabled={!props.isEdit}
                            value={props.condition} 
                            onChange={(e: any) => props.setCondition(e.target.value)}
                        >
                            { props.condition === "" ? (
                                <option value="">...</option>
                            ) : null }
                            { props.listCondition.map((iterator: any, idx: number) => (<option key={idx} value={iterator.identifier}>{iterator.name}</option>)).sort((a : any, b : any) => { return a.props.children > b.props.children ? 1 : -1; }) }
                        </Form.Select>
                    </FormGroup>
                </Col>
            </Row>
            <Row sm="12" className="ms-1 me-1"><Col className="ps-1 pe-1" ><hr /></Col></Row>
            <fieldset className="ms-2 me-2">
                <legend>{display.legend.period}</legend>
                <Row>
                    <Col>
                        <FormGroup>
                            <Form.Label htmlFor="form-initial">{display.label.date_initial}</Form.Label>
                            <Form.Control id="form-initial" name="initial" required placeholder={display.example.initial}
                                disabled={!props.isEdit}
                                value={props.initial}
                                onChange={(e: any) => props.setInitial(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Form.Label htmlFor="form-final">{display.label.date_final}</Form.Label>
                            <Form.Control id="form-final" name="final" required placeholder={display.example.final}
                                disabled={!props.isEdit}
                                value={props.final}
                                onChange={(e: any) => props.setFinal(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </fieldset>
        </>
    );

}

export default RuleBenefitRecord;
